export interface Subscriber {
  id?: number;
  created_at?: Date;
  updated_at?: Date;
  organization_id?: string;
  name: string;
  business_name?: string | null;
  business_identification?: string | null;
  phone?: string | null;
  email?: string | null;
  type?: 'business' | 'personal' | null;
  personal_identification?: string | null;
  zipcode?: string | null;
  city?: string | null;
  state?: string | null;
  street?: string | null;
  address_complement?: string | null;
}

interface ApiResponse<T = any> {
  message: string;
  data: T;
  status: number;
}

class SubscriberService {
  private baseUrl: string;

  constructor(baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:3030') {
    this.baseUrl = baseUrl;
  }

  private async request<T>(
    endpoint: string,
    options: RequestInit = {}
  ): Promise<ApiResponse<T>> {
    const url = `${this.baseUrl}${endpoint}`;

    // Get token from cookie like other services
    const token = document.cookie.split('sgo_access_token=')[1]?.split(';')[0];
    const config: RequestInit = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        ...options.headers,
      },
      ...options,
    };

    try {
      const response = await fetch(url, config);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || data.error || `HTTP error! status: ${response.status}`);
      }

      return data;
    } catch (error) {
      console.error('API request failed:', error);
      throw error;
    }
  }

  // Listar todos os assinantes
  async getSubscribers(): Promise<Subscriber[]> {
    const response = await this.request<Subscriber[]>('/subscribers', {
      method: 'GET',
    });
    return response.data;
  }

  // Obter assinante específico
  async getSubscriber(id: number): Promise<Subscriber> {
    const response = await this.request<Subscriber>(`/subscribers/${id}`, {
      method: 'GET',
    });
    return response.data;
  }

  // Criar novo assinante
  async createSubscriber(subscriber: Partial<Subscriber>): Promise<Subscriber> {
    const response = await this.request<Subscriber>('/subscribers', {
      method: 'POST',
      body: JSON.stringify(subscriber),
    });
    return response.data;
  }

  // Atualizar assinante
  async updateSubscriber(id: number, updates: Partial<Subscriber>): Promise<Subscriber> {
    const response = await this.request<Subscriber>(`/subscribers/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(updates),
    });
    return response.data;
  }

  // Deletar assinante
  async deleteSubscriber(id: number): Promise<void> {
    await this.request<null>(`/subscribers/${id}`, {
      method: 'DELETE',
    });
  }
}

const subscriberService = new SubscriberService();
export default subscriberService;
